import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getBoundingClientRect } from '../../../utils/dom';
import Product from './product';
import {map} from 'lodash';

export default class ProductRow extends Component {
  state = {
    leftTrackingBoundary: 0,
    rightTrackingBoundary: 0
  };

  componentDidMount() {
    const {
      left: leftTrackingBoundary,
      right: rightTrackingBoundary
    } = getBoundingClientRect(this._node);
    this.setState({ leftTrackingBoundary, rightTrackingBoundary });
  }

  render() {
    const { sold_content_type, hide_product_info_button } = this.props;

    return (
      <div className="product-row" ref={node => this._node = node}>
        {
          map(this.props.products, (props, index) => (
            <Product key={props.id}
              data_index={index}
              sold_content_type={sold_content_type}
              hide_product_info_button={hide_product_info_button}
              {...props}
              {...this.state}
            />
          ))
        }
      </div>
    );
  }
}

ProductRow.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  sold_content_type: PropTypes.string,
  hide_product_info_button: PropTypes.bool
};

ProductRow.defaultProps = {
  products: []
};
